import { createFileRoute, notFound } from '@tanstack/react-router'
import { previewProps } from '../hero/preview.ts'
import { heroVersion, loadHero } from '../hero/versions.ts'

type PreviewSearch = { stan?: 'starting' | 'failed' }

/**
 * One hero version, full screen, outside the funnel: `/podglad/h3`. The gallery (`/podglad`)
 * frames this page at device sizes. `?stan=starting|failed` shows the CTA's loading and error.
 */
export const Route = createFileRoute('/podglad/$id')({
  validateSearch: (raw: Record<string, unknown>): PreviewSearch =>
    raw.stan === 'starting' || raw.stan === 'failed' ? { stan: raw.stan } : {},
  loader: async ({ params }) => {
    const version = heroVersion(params.id)
    if (!version) throw notFound()
    return (await loadHero(version)).Hero
  },
  component: HeroPreview,
})

function HeroPreview() {
  const Hero = Route.useLoaderData()
  const { stan } = Route.useSearch()
  return <Hero {...previewProps(stan)} />
}
